import _ from 'lodash';

export const hasUnsavedChanges = (originalObject, updatedObject) => {
  return !_.isEqual(originalObject, updatedObject);
};
